import globalUseStyles from '../../../../styles/globalCustomStyles';

import { Card, Typography } from '@mui/material';
import { useRecordContext, useTranslate } from 'react-admin';
import CustomTable from '../../../Table/CustomTable';
import { value_with_unit } from '../../../aegeon/helper';

const SiteGeneralInformationDetailsContentLeftBottom = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();

  const record = useRecordContext();

  const period_of_reporting = (() => {
    if (record?.airtable?.reporting_start_date !== null && record?.airtable?.reporting_end_date !== null) {
      let start = record?.airtable?.reporting_start_date
      let end = record?.airtable?.reporting_end_date
      let value = `${start} - ${end}`
      return value
    }
    else return null
  })()

  const esg_modality = record?.airtable?.esg_modality ? record?.airtable?.esg_modality?.map((item) => item.name).join(", ") : null;

  const is_reportable = record?.airtable?.reporting_n_reportable_site === "OUI" ? "Reportable" : "Non reportable";

  // The rows tooltips are translated in the CustomTable component
  const rows = [
    { name: t('sites.general_information.period_of_reporting'), value: period_of_reporting, tooltip: 'sites.general_information.period_of_reporting_no_data' },
    { name: t('sites.general_information.reporting_type'), value: esg_modality, tooltip: 'sites.general_information.reporting_type_no_data' },
    { name: t('sites.general_information.divided_in_buildings'), value: record?.airtable?.divided_in_buildings === true ? "Oui" : null, tooltip_with_value: true, tooltip: 'sites.general_information.divided_in_buildings_tooltip', hide_if_null: true },
    { name: t('sites.general_information.synoptic_quality_reporting_n'), value: record?.airtable?.current_synoptic_quality_reporting, tooltip: 'sites.general_information.synoptic_quality' },
    { name: t('sites.general_information.reporting_statut'), value: is_reportable, tooltip_info: 'sites.general_information.reporting_statut_definition', tooltip_with_value: (is_reportable === "Non reportable"), tooltip: 'sites.general_information.reporting_statut_definition' },
    { name: t('sites.general_information.surface_consumption_n_2'), value: value_with_unit(record?.airtable?.reporting_n_2_surface_energy_performance, "kWh EF PCI / m²"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.surface_consumption_n_1'), value: value_with_unit(record?.airtable?.reporting_n_1_surface_energy_performance, "kWh EF PCI / m²"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.total_consumption'), value: value_with_unit(record?.airtable?.reporting_n_total_energy_consumption, "kWh EF PCI"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.surface_consumption'), value: value_with_unit(record?.airtable?.reporting_n_surface_energy_performance, "kWh EF PCI / m²"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.co2_total_consumption'), value: value_with_unit(record?.airtable?.reporting_n_total_ghg_emissions, "kg eq CO₂"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.co2_surface_consumption'), value: value_with_unit(record?.airtable?.reporting_n_carbon_intensity, "kg eq CO₂ / m²"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.water_total_consumption'), value: value_with_unit(record?.airtable?.reporting_n_total_water_consumption, "m³"), tooltip: 'sites.general_information.reporting_no_data' },
    { name: t('sites.general_information.final_energy_perf_bpe_oid_ref'), value: value_with_unit(record?.airtable?.final_energy_perf_bpe_oid_ref, "kWh EF / m²"), tooltip: 'sites.general_information.final_energy_perf_bpe_oid_ref_no_data' },
    { name: t('sites.general_information.co2_perf_bpe_oid_ref'), value: value_with_unit(record?.airtable?.co2_perf_bpe_oid_ref, "kg eq CO₂ / m²"), tooltip: 'sites.general_information.co2_perf_bpe_oid_ref_no_data' },
    { name: t('sites.general_information.water_perf_bpe_oid_ref'), value: value_with_unit(record?.airtable?.water_perf_bpe_oid_ref, "m³"), tooltip: 'sites.general_information.water_perf_bpe_oid_ref_no_data' },
  ]

  return (
    <Card className={globalClasses.DetailCard}>
      <Typography display="block" variant="h8">
        <span><b>{t('sites.general_information.left_bottom_panel.title')}</b></span>
      </Typography>
      <div className={globalClasses.DetailCardTableSubtitle} />
      <CustomTable rows={rows} defaultTooltip={"sites.no_data_tooltip"} />
    </Card>
  );
};

export default SiteGeneralInformationDetailsContentLeftBottom;

